import React from 'react'

import {
  Body2,
  Bold,
  Box,
  Color,
  Display,
  Divider,
  FlexDirection,
  FontFamily,
  Join,
  Space,
} from '@gousto-internal/citrus-react'

function BoxPricesRow({
  boxType,
  portion,
  description,
  additionalLine,
}: {
  boxType: string
  portion: string
  description: string
  additionalLine?: string
}) {
  return (
    <>
      <Box
        display={[Display.Block, Display.None]}
        style={{ borderRadius: '8px' }}
        boxShadow="0 2px 8px rgba(0, 0, 0, 0.1)"
        bg={Color.White}
      >
        <Box
          bg={Color.ColdGrey_600}
          style={{ borderRadius: '8px 8px 0 0' }}
          paddingH={4}
          paddingV={3}
        >
          <Body2 size={2} fontFamily={FontFamily.Bold} color={Color.White}>
            {boxType}
          </Body2>
        </Box>

        <Box paddingH={4} paddingV={3}>
          <Box paddingH={2} paddingV={2} display={Display.Flex} flexDirection={FlexDirection.Row}>
            <Box flexBasis="30%">
              <Body2 fontFamily={FontFamily.Bold}>Great for</Body2>
            </Box>
            <Box flexBasis="70%">
              <Body2 size={2}>{portion}</Body2>
              {additionalLine && (
                <>
                  <Space size={2} />
                  <Body2 size={2}>{additionalLine}</Body2>
                </>
              )}
            </Box>
          </Box>
          <Divider />
          <Box paddingH={2} paddingV={2} display={Display.Flex} flexDirection={FlexDirection.Row}>
            <Box flexBasis="30%">
              <Body2 size={2} fontFamily={FontFamily.Bold}>
                First box price
              </Body2>
            </Box>
            <Box flexBasis="70%">
              <Body2 size={2}>{description}</Body2>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box display={[Display.None, Display.Block]}>
        <Box paddingH={3} paddingV={3} display={Display.Flex} flexDirection={FlexDirection.Row}>
          <Box paddingRight={3} flexBasis="20%">
            <Body2 size={2}>
              <Bold>{boxType}</Bold>
            </Body2>
            <Space size={3} />
          </Box>
          <Box paddingRight={3} flexBasis="40%">
            <Body2 size={2}>{portion}</Body2>
            {additionalLine && (
              <>
                <Space size={5} />
                <Body2 size={2}>{additionalLine}</Body2>
              </>
            )}
          </Box>
          <Box paddingRight={3} flexBasis="40%">
            <Body2 size={2}>{description}</Body2>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export function BoxPricesTable() {
  return (
    <>
      <Box
        display={[Display.None, Display.Block]}
        style={{ borderRadius: '8px' }}
        boxShadow="0 2px 8px rgba(0, 0, 0, 0.1)"
        bg={Color.White}
        paddingH={3}
        paddingV={3}
        width="100%"
      >
        <Box bg={Color.ColdGrey_600} display={Display.Flex} paddingH={4} paddingV={3}>
          <Box flexBasis="20%">
            <Body2 size={2} fontFamily={FontFamily.Bold} color={Color.White}>
              Box Size
            </Body2>
          </Box>
          <Box flexBasis="40%">
            <Body2 size={2} fontFamily={FontFamily.Bold} color={Color.White}>
              Great for
            </Body2>
          </Box>
          <Box flexBasis="40%">
            <Body2 size={2} fontFamily={FontFamily.Bold} color={Color.White}>
              First box price
            </Body2>
          </Box>
        </Box>
        <Join with={<Divider />}>
          <BoxPricesRow
            boxType="1 person box"
            portion="Single person households"
            description="Get 5 meals for the week for just £17.50"
          />
          <BoxPricesRow
            boxType="2 person box"
            portion="2 adults (or 1 adult + leftovers)"
            additionalLine="1 adult and 1-2 children"
            description="Get 5 meals for the week for just £22.38"
          />
          <BoxPricesRow
            boxType="3 person box"
            portion="3 adults (or 2 adults + leftovers)"
            additionalLine=" 2 adults and 1-2 children"
            description="Get 5 meals for the week for just £30"
          />
          <BoxPricesRow
            boxType="4 person box"
            portion="4 adults (or 2-3 adults + leftovers)"
            additionalLine=" 2 adults and 2-3 children"
            description="Get 5 meals for the week for just £30.88"
          />
          <BoxPricesRow
            boxType="5 person box"
            portion="5 adults (or 3-4 adults + leftovers)"
            additionalLine=" 2-3 adults and 2-4 children"
            description="Get 3 meals for the week for just £28.38"
          />
        </Join>
      </Box>

      <Box display={[Display.Block, Display.None]}>
        <Join with={<Space size={4} />}>
          <BoxPricesRow
            boxType="1 person box"
            portion="Single person households"
            description="Get 5 meals for the week for just £17.50"
          />
          <BoxPricesRow
            boxType="2 person box"
            portion="2 adults (or 1 adult + leftovers)"
            additionalLine="1 adult and 1-2 children"
            description="Get 5 meals for the week for just £22.38"
          />
          <BoxPricesRow
            boxType="3 person box"
            portion="3 adults (or 2 adults + leftovers)"
            additionalLine=" 2 adults and 1-2 children"
            description="Get 5 meals for the week for just £30"
          />
          <BoxPricesRow
            boxType="4 person box"
            portion="4 adults (or 2-3 adults + leftovers)"
            additionalLine=" 2 adults and 2-3 children"
            description="Get 5 meals for the week for just £30.88"
          />
          <BoxPricesRow
            boxType="5 person box"
            portion="5 adults (or 3-4 adults + leftovers)"
            additionalLine=" 2-3 adults and 2-4 children"
            description="Get 3 meals for the week for just £28.38"
          />
        </Join>
      </Box>
    </>
  )
}
